export const timeSettings = {
  delayTime: 100
}

export const statusOfCompany = {
  statuses: ['Deleted', 'Approved', 'Pending', 'NotYet'],
  resendBtn: ['NotYet'],
  editBtn: ['Approved', 'Pending'],
  deleteBtn: ['Approved', 'Pending', 'NotYet'],
  approveBtn: ['Pending']
}

export const categoryOfCompany = {
  categories: ['Automobiles', 'Education']
}

export const visibilityStatusOfCompany = {
  statuses: ['Disabled', 'Enabled']
}

export const sortWay = {
  'company': 'BlitzInvitation.Company',
  'category': 'Metadata.category',
  'status': 'BlitzInvitation.Status',
  'blitzCard.status': 'BlitzCard.Status'
}

export const listingSortWay = {
  'name': 'ListingInvitation.Name',
  'company': 'ListingInvitation.Company',
  'email': 'ListingInvitation.Email'
}

export const attendeeMessages = [
  { Id: 'AttendeeToAttendee', Name: 'Attendee To Attendee' },
  { Id: 'AttendeeToSpeaker', Name: 'Attendee To Speaker' },
  { Id: 'AttendeeToBlitzParticipant', Name: 'Attendee To Blitz Participant' },
  { Id: 'AgendaSessionQuestion', Name: 'Agenda Session Question' },
  { Id: 'ContactUs', Name: 'Contact Us' }
]

export const activityDisplayLocation = ['Email', 'Package', 'Badge']

export default {
  timeSettings,
  statusOfCompany,
  categoryOfCompany,
  visibilityStatusOfCompany,
  sortWay,
  listingSortWay,
  activityDisplayLocation,
  attendeeMessages
}



// WEBPACK FOOTER //
// ./src/modules/settings/index.js